import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/app-setting/redux/actions';
import EmbeddedPageFrame from '../common/ui/EmbeddedPageFrame';
import { AppConfigTab } from './appConfig/AppConfigTab';

export class AppConfiguration extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
  }
  render() {
    const { appSetting, actions, match } = this.props;
    const { projectDetail } = appSetting;
    if (!projectDetail) {
      return '';
    }
    const { dateFormat, dataMaskingConfig } = projectDetail;
    const { projectId, version } = match.params;
    return (
      <EmbeddedPageFrame embedded={this.props.embedded}>
        <AppConfigTab
          projectId={projectId}
          dateFormat={dateFormat}
          updateDateFormat={actions.updateDateFormat}
          version={version}
          toggle={this.toggle}
          actions={actions}
          dataMaskingConfig={dataMaskingConfig}
        />
      </EmbeddedPageFrame>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppConfiguration);
